require('./dist/angular-gettext.js');
module.exports = 'gettext';



//////////////////
// WEBPACK FOOTER
// ./~/angular-gettext/index.js
// module id = 1112
// module chunks = 1